import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  text-align: center;
  font-weight: 700;
  text-transform: uppercase;
  height: 50px;
  background: #e1e1e1;
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;
